module.exports = __webpack_public_path__ + "media/images/pages/peel/about-84d92649010e2e74aa2cc53f9767ab97.jpg";